import {
  Button,
  Card,
  Table,
  Space,
  notification,
  Form,
  Upload,
  Modal,
  Input,
  Select,
} from "antd";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";
import { useNavigate } from "react-router-dom";


function CategoryManagement() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categorydata, setCategoryData] = useState<any>([]);
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const navigate = useNavigate();
  const handleFileChange = (info: any) => {
    if (info.file.status === "done") {
      const fileUrl = info.file.response?.location || info.file.response?.url; // AWS usually returns `location`
      if (fileUrl) {
        setFileUrl(fileUrl);
        form.setFieldsValue({ serviceCategory: fileUrl }); // Update form field value
      }
    } else if (info.file.status === "error") {
      notification.error({ message: "File upload failed!" });
    }
  };
  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []);
  const S3_BUCKET = awsData?.bucketName;
  const uploadProps = {
    name: "file",
    action: `https://s3.${AWS.config.region}.amazonaws.com/${S3_BUCKET}/`,
    headers: {
      "x-amz-acl": "public-read",
      "Content-Type": "multipart/form-data",
    },
    onChange: handleFileChange,
    customRequest: async (options: any) => {
      const { onSuccess, onError, file } = options;
      const params = {
        Bucket: S3_BUCKET,
        Key: `category/${file.name}`,
        Body: file,
        // ACL: "public-read",
        ContentType: file.type,
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          onError(err);
          notification.error({ message: "File upload failed!" });
        } else {
          setFileUrl(data.Location); // Set file URL on successful upload
          form.setFieldsValue({ serviceCategory: data.Location });
          onSuccess(data);
          notification.success({ message: "File uploaded successfully!" });
        }
      });
    },
  };

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        categoryTitle: values.categoryTitle,
        categoryImage: fileUrl, // Use uploaded file URL
      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_CATEGORY, obj);
      if (postRequest.status) {
        notification.success({ message: "Category added successfully!" });

        form.resetFields(); // Reset form
        setFileUrl(null); // Ensure proper cleanup
        fetchcategory(page, pageSize); // Fetch new categories without refreshing
        setIsModalOpen(false); // Close modal without refreshing the whole page
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "categoryTitle", dataIndex: "categoryTitle" },

    {
      title: "categoryImage",
      dataIndex: "categoryImage",
      render: (url: string) => (
        <img src={url} alt="category" style={{ width: 100, height: 100 }} />
      ),
    },

    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>
            Delete
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/Admin/adminCategory/updatecategory/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const fetchcategory = async (
    currentPage: number,
    currentPageSize: number
  ) => {
    try {
      setIsLoading(true);
      const obj = {
        query: "query",
        page: currentPage,
        take: currentPageSize,
      };

      const url = API.LISTING_CATEGORY;
      const response: any = await POST(url, obj);

      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_url = `${API.DELETE_CATEGORY}${id}`;
      const data: any = await DELETE(delete_url);

      if (data.status) {
        notification.success({ message: "category deleted successfully!" });
        fetchcategory(page, pageSize);
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this review?"
    );
    if (confirm) {
      handleDelete(id);
    }
  };

  useEffect(() => {
    fetchcategory(page, pageSize);
  }, [page, pageSize]);

  const filterCategoryData = async (values: any) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_CATEGORY;
      const response: any = await POST(api, values);

      if (response?.data) {
        setCategoryData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Category Management </h1>
            <button
              className="banner-button"
              onClick={() => setIsModalOpen(true)}
            >
              Create Category
            </button>
          </div>
        )}
      </div>
      <Card className="mb-4">
        <Form
          form={form}
          layout="inline"
          onFinish={filterCategoryData}
          style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
        >
          <Form.Item name="categoryTitle">
            <Select
              placeholder="Select category"
              allowClear
              style={{ width: "200px" }}
              options={data.map((item: any) => ({
                value: item.categoryTitle,
                label: item.categoryTitle,
              }))}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Filter
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={() => {
                form.resetFields();
                setCategoryData([]); // Clear filtered data
                fetchcategory(page, pageSize);
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <div>
        <Card>
          <div className="table-responsive" style={{ overflowX: "auto" }}>
            <Table
              columns={columns}
              dataSource={categorydata.length ? categorydata : data}
              loading={isLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                total: meta?.total,
                showSizeChanger: true,
                onChange: (currentPage: number, currentSize: number) => {
                  setPage(currentPage);
                  setPageSize(currentSize);
                },
              }}
              rowKey={(record: any) => record.id || record.reviwerName}
              scroll={{ x: "max-content" }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title="Add category"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Form.Item
            name="categoryTitle"
            label="categoryTitle"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="categoryImage"
            label="Image"
            rules={[{ required: true }]}
          >
            <Upload {...uploadProps}>
              <Button className="w-full">Upload</Button>
            </Upload>
            {fileUrl && (
              <img src={fileUrl} alt="Uploaded" className="w-24 h-24 mt-2"
                style={{ width: "20%", height: "20vh", objectFit: "cover" }} />
            )}
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default CategoryManagement;
